
export const DASHBOARD_BUTTON_HOVER_COLOR = 'rgba(255, 255, 255, 0.20)';  //same color as the design system's IconButton hover
